import {
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

// Hangar-style per-application Overview tab. The full card grid (EnvMatrix,
// GoldenSignals, RollbarInbox, LastDeploy, OpenPRs, DORA snapshot) lands in
// follow-up PRs — this first PR scaffolds the plugin shape and registers the
// tab so the catalog-flip from Phase 0 has something to light up against.
//
// Pattern mirrors plugins/argo-workflows/src/plugin.tsx:77-100.
const rollupEntityContent = EntityContentBlueprint.make({
  params: {
    path: '/rollup',
    title: 'Overview',
    loader: () =>
      import('./components/RollupPage').then(m => <m.RollupPage />),
    // Only mount for Components the catalog knows have a helmfile release.
    // Deki catalog-info.yaml gains this annotation in the companion PR.
    filter: 'kind:component,metadata.annotations.expertportal/helmfile-release',
  },
});

export const appRollupPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'app-rollup',
  extensions: [rollupEntityContent],
});

export default appRollupPlugin;
